import React from "react";
import { Line as ReChartsLine, type LineProps as ReChartsLineProps } from "recharts";

import { useScoped } from "~/tools/impulse";

import type { ChartDataPoint } from "./_create-chart-data-points";
import { getLineColorByIndex } from "./_get-line-color-by-index";
import type { LegendContentState } from "./_legend-content";

interface LineProps extends Pick<ReChartsLineProps, "connectNulls"> {
	name: string;
	index: number;
	legendState: LegendContentState;
}

export const Line: React.FC<LineProps> = React.memo(({ name, index, legendState, connectNulls }) => {
	const hide = useScoped((scope) => !legendState.isLabelVisible(scope, name), [legendState, name]);
	const dataKey = React.useCallback(({ values }: ChartDataPoint) => values[index], [index]);

	return (
		<ReChartsLine
			connectNulls={connectNulls}
			dataKey={dataKey}
			dot={false}
			hide={hide}
			isAnimationActive={false}
			legendType="line"
			name={name}
			stroke={getLineColorByIndex(index)}
			strokeWidth={1.5}
			type="linear"
			zIndex={500}
		/>
	);
});

if (import.meta.env.DEV) {
	Line.displayName = "TimeSeriesChart.Line";
}
